module.exports = __webpack_public_path__ + "img/disLike.9d319f04.svg";